import { Injectable } from "@angular/core";
import { HttpRequest, HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpResponse } from "@angular/common/http";
import { tap } from "rxjs/operators";
import { Observable } from "rxjs";
import { AdminService } from "./admin.service";
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router";
import { apiUrl } from "../global/global";

@Injectable({
  providedIn: "root",
})
export class InterceptorService implements HttpInterceptor {
  constructor(private admin: AdminService, private router: Router, private toastrService: ToastrService,) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token = localStorage.getItem("adminToken")
      ? localStorage.getItem("adminToken")
      : "";
    let noToken = localStorage.getItem("noToken")
      ? localStorage.getItem("noToken")
      : "";
    if (token) {
      req = req.clone({
        headers: req.headers.set("authorization", atob(token)),
      });
    }

    if (this.admin.showLoader) this.admin.loader(true);
    else this.admin.showLoader = true;
    return next.handle(req).pipe(
      tap(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            this.admin.loader(false);
          }
        },
        (err: any) => {
          this.admin.loader(false);
          if (err instanceof HttpErrorResponse) {
            if (err.error.statusCode == 401) {
              if ((err.error.message == "Your account has been blocked by the Admin. Please contact support@support.com.")) {

                this.admin.putData(apiUrl._logout, {}).subscribe(
                  async (res) => {

                  },
                  (err) => {
                    // console.log(err, "errr");
                  }
                );
                this.admin.errorAlert(err.error.message, true, "Oops...");
              } else if (err.error.message == "The token is not valid or Admin not Found!") {
                this.clear()
              }

              else {
                this.admin.errorAlert(err.error.message, true, "Oops...");
              }


            }
            // else
            //   if (err.error.statusCode == 402)
            //     this.admin.errorAlert(err.error.message, true);
            //   else
            //     if (err.error.statusCode == 403)
            //       this.admin.errorAlert(err.error.message, true);
            else {
              if (err.error.message == 'Tax clause conclusion missing in Individual ! Please check' || err.error.message == 'Tax clause conclusion missing in Company ! Please check' || err.error.message == 'Tax clause conclusion missing in both Individual & Company ! Please check' || err.error.message == 'A tax clause between these countries exist which is not in published state.'
                || err.error.message == 'You have to add atleast one comment for rejecting this tax clause.') {
                this.toastrService.error(err.error.message);

              } else {
                this.admin.errorAlert(err.error.message, false, "Oops...");
              }

            }
          }
        }
      )
    );
  }

  clear() {
    localStorage.removeItem("adminToken");
    localStorage.removeItem("adminDetail");
    localStorage.removeItem("firstName");
    localStorage.removeItem("lastName");
    localStorage.removeItem("image");
    localStorage.removeItem("s3Url");
    localStorage.removeItem("s3Folders");
    localStorage.removeItem("baseUrl");
    localStorage.removeItem("phoneNumber");
    localStorage.removeItem("fcmToken");
    localStorage.removeItem("userPermissions");
    localStorage.removeItem("userName");
    localStorage.removeItem("adminType");
    this.router.navigate(["/"]);
  }
}
